<div class="confirmation-dialog">
  <h2 class="confirmation-dialog__modal-title" *ngIf="heading">{{ heading }}</h2>
  <div mat-dialog-content>
    <ng-content></ng-content>
  </div>
  <div mat-dialog-actions [align]="'end'">
    <button mat-button *ngIf="!closeSingle" (click)="onCancelEvent()">Cancel</button>
    <button mat-button *ngIf="closeSingle" mat-dialog-close>Cancel</button>
    <button mat-flat-button color="warn" mat-dialog-close (click)="closeSingle?onConfirmEventSingle():onConfirmEvent()">
      Confirm
    </button>
  </div>
</div>